import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { BatchAlertService } from 'src/app/services/batch-alert.service';
import { RootScopeService } from 'src/app/services/root-scope.service';

@Component({
  selector: 'app-archived-batch-alert',
  templateUrl: './archived-batch-alert.component.html',
  styleUrls: ['./archived-batch-alert.component.scss']
})
export class ArchivedBatchAlertComponent {
  totalRecords: number = 8;
  constructor(
    public batchAlertService: BatchAlertService,
    private apiService: ApiService,
    public dialog: MatDialog,
    public rootService: RootScopeService
  ) { }


  openFilter() {
    this.rootService.openAdminFilterDialog = true;
  }
 /* istanbul ignore next */
 rowSelection(data) {}
}
